// ============================================
// CENTRALIZED EXTERNAL ACTIVITY TYPES
// Used across all client-facing components
// ============================================

export const EXTERNAL_ACTIVITY_TYPES = [
  { value: 'running', label: '🏃 Running', emoji: '🏃' },
  { value: 'cycling', label: '🚴 Ciclismo', emoji: '🚴' },
  { value: 'swimming', label: '🏊 Natación', emoji: '🏊' },
  { value: 'hiking', label: '🥾 Senderismo', emoji: '🥾' },
  { value: 'yoga', label: '🧘 Yoga', emoji: '🧘' },
  { value: 'strength', label: '💪 Fuerza / Gym', emoji: '💪' },
  { value: 'cardio', label: '❤️ Cardio', emoji: '❤️' },
  { value: 'mobility', label: '🤸 Movilidad', emoji: '🤸' },
  { value: 'crosstraining', label: '🔄 Cross-training', emoji: '🔄' },
  { value: 'walking', label: '🚶 Caminar', emoji: '🚶' },
  { value: 'trail_running', label: '🏔️ Trail Running', emoji: '🏔️' },
  { value: 'martial_arts', label: '🥋 Artes marciales', emoji: '🥋' },
  { value: 'acrobatics', label: '🤸‍♂️ Acrobacias', emoji: '🤸‍♂️' },
  { value: 'pilates', label: '🧘‍♀️ Pilates', emoji: '🧘‍♀️' },
  { value: 'crossfit', label: '🏋️ CrossFit', emoji: '🏋️' },
  { value: 'climbing', label: '🧗 Escalada', emoji: '🧗' },
  { value: 'rowing', label: '🚣 Remo', emoji: '🚣' },
  { value: 'boxing', label: '🥊 Boxeo', emoji: '🥊' },
  { value: 'dance', label: '💃 Baile', emoji: '💃' },
  { value: 'other', label: '🏋️ Otro (personalizado)', emoji: '🏋️' }
];

// Helper function to get activity display info
export const getActivityInfo = (activityType) => {
  const activity = EXTERNAL_ACTIVITY_TYPES.find(a => a.value === activityType);
  return activity || { value: activityType, label: activityType, emoji: '🏋️' };
};

// Helper function to get emoji for activity type
export const getActivityEmoji = (activityType) => {
  const activity = EXTERNAL_ACTIVITY_TYPES.find(a => a.value === activityType);
  return activity?.emoji || '🏋️';
};

export default EXTERNAL_ACTIVITY_TYPES;
